import React from 'react'
import { Link } from 'react-router-dom';
import { useModal } from '../../../contexts/ModalContext';
import { BaseUrl } from '../../../helper/BaseUrl';

export default function IDBanner({data}) {
const { openQueryModal } = useModal();
  return (
    <section className="integration-detail-banner">
      <img src="/assets/images/banner-detail-img.webp" alt="Banner" className="img-responsive bg-img" />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="breadcumb-sec">
              <ul className='dynamic-breadcrumb'>
                <li><Link to={"/"}>Home</Link></li>
                <li><Link to={"/integration"}>Integrations</Link></li>
                <li>{data?.name?.slice(0, 12) + ""}</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8">
            <div className="logo-sec">
              <img src={`${BaseUrl}${data?.logo}`} className="img-responsive post-img" alt={data?.name}  />
              <h1 className="heading">Mobility Infotech + <span className="gradient-color">{data?.name}</span></h1>
              <p>{data?.banner_short_description}</p>
              <div className="dynamic-btn">
                <Link className="theme-btn" onClick={openQueryModal} ><span>Get Started</span></Link>
                <a href="#watch-video" className="theme-btn white-btn"><span>Watch Tutorial</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
